import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

type ToolType =
  | "fire_calculator"
  | "fd_calculator"
  | "cagr_calculator"
  | "ssy_calculator"
  | "rd_calculator"
  | "nsc_calculator"
  | "hra_calculator";

export interface FireCalculatorResponse {
  monthly_expense: number;
  current_age: number;
  retirement_age: number;
  inflation_rate: number;
  coast_fire_age: number;
  expense_today: number;
  expense_at_40: number;
  lean_fire: number;
  fire: number;
  fat_fire: number;
  coast_fire: number;
}

interface ToolResponse {
  success: boolean;
  data: {
    _id: string;
    user_id: string;
    fire_calculator: FireCalculatorResponse;
  };
  error: {
    message: string | null;
  };
}

interface UpdateToolRequest {
  type: ToolType;
  payload: any;
  is_save: boolean;
}

export const toolsApi = createApi({
  reducerPath: "toolsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["tool"],
  endpoints: (builder) => ({
    getToolDetails: builder.query<ToolResponse, void>({
      query: () => ({
        url: `/tool`,
        method: "GET",
      }),
    }),
    updateTool: builder.mutation<
      {
        success: boolean;
        data: any;
        error: { message: string | null };
      },
      UpdateToolRequest
    >({
      query: ({ type, payload, is_save }) => ({
        url: `/tool`,
        method: "PATCH",
        data: {
          type,
          payload,
          is_save,
        },
      }),
    }),
    generateRentReceipt: builder.mutation({
      query: (data) => ({
        url: `/tool/receipt`,
        method: "POST",
        data,
      }),
    }),
  }),
});

export const {
  useLazyGetToolDetailsQuery,
  useUpdateToolMutation,
  useGenerateRentReceiptMutation,
} = toolsApi;
